/**
 * Parse a Contact.labelIds comma-separated string into a deduplicated array
 * of positive integers. Matches the parsing rule used at LabelsView.tsx and
 * AddressBookView.tsx: split on `,`, trim each token, drop empty /
 * whitespace-only / NaN / non-positive tokens, then dedupe preserving
 * first-seen order.
 */
export function parseContactLabelIds(input: string | null | undefined): number[] {
    if (!input) return []
    const seen = new Set<number>()
    const result: number[] = []
    for (const raw of input.split(',')) {
        const trimmed = raw.trim()
        if (!trimmed) continue
        const id = Number(trimmed)
        if (!Number.isFinite(id) || id <= 0) continue
        if (seen.has(id)) continue
        seen.add(id)
        result.push(id)
    }
    return result
}
